import { useLabels } from 'wsm-common-data';
import { useLocationsMakeFilter } from './useLocationsMakeFilter';
import { useLocationsRadius } from './useLocationsRadius';
import {
	prepareMakeFilters,
	prepareRadiusFilter
} from '../utils/prepareFilterItems';
import { FILTER_TYPES } from '../global-constants';

export const useActiveFilters = (isReady) => {
	const labels = useLabels();
	const { makeFilters, removeMakeFilter, resetMakeFilters } =
		useLocationsMakeFilter(isReady);
	const { radius, updateRadius } = useLocationsRadius(isReady);

	const filters = [
		...prepareMakeFilters(makeFilters),
		prepareRadiusFilter(radius, labels)
	].filter(Boolean);

	const filterRemoveHandlers = {
		[FILTER_TYPES.MAKE]: (id) => removeMakeFilter(id),
		[FILTER_TYPES.RADIUS]: () => updateRadius()
	};
	const handleFilterRemove = (type, id) => {
		if (!isReady) return;
		filterRemoveHandlers[type]?.(id);
	};

	const handleClearAllFilters = () => {
		if (!isReady) return;
		updateRadius();
		resetMakeFilters();
	};

	return { filters, handleFilterRemove, handleClearAllFilters };
};
